import React, { FC } from 'react'
import { Location } from '@teschglobal/tg-fhir-react-components'
import type { Location as FHIRLocation } from '@teschglobal/tg-fhir-react-components/dist/types'
import { useGlobalState } from '../../../../../hooks/store/useGlobalState'
import useFhirConfig from '../../../../../hooks/admin/useFhirConfig'

type LocationDetailProps = {
    resource: FHIRLocation | null
}

const LocationDetail: FC<LocationDetailProps> = ({ resource }) => {
    const { providerDirectoryFhirConfig, handleSelectOrganization, handleSelectLocation } = useFhirConfig()
    const locationFromState = useGlobalState(state => state.location)
    resource = resource || locationFromState

  if (!resource) {
    return (
      <div className="text-center" role="status" aria-live="polite" aria-atomic="true">
        Not Found
      </div>
    )
  }

    return (
        <section>
            <h3>Location</h3>
            <Location
                data={resource}
                fhirApiConfig={providerDirectoryFhirConfig}
                onSelectOrganization={handleSelectOrganization}
                onSelectLocation={handleSelectLocation}
            />
        </section>
    )
}

export default LocationDetail